import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import ActionBar from "~/layout/ActionBar";
import { Button, Loading, Modal, Icon } from "~/components";
import {
	saleCallSourceActions,
	saleCallSourceErrorSelector,
	saleCallSourceFilterSelector,
	saleCallSourceItemsSelector,
	saleCallSourceLoadingSelector,
	saleCallSourcePaginationSelector
} from "../saleCallSourceSlice";
import { apiError, handleRequest } from "~/utils";
import { saleApi } from "~/api";
import {
	SaleCallSourceTable,
	SaleCallSourceUploadForm,
	SaleCallSourceDetail
} from "../components";

function SaleCallSource() {

	const dispatch   = useDispatch();
	const items      = useSelector(saleCallSourceItemsSelector);
	const loading    = useSelector(saleCallSourceLoadingSelector);
	const error      = useSelector(saleCallSourceErrorSelector);
	const pagination = useSelector(saleCallSourcePaginationSelector);
	const filter     = useSelector(saleCallSourceFilterSelector);

	const [itemEdit, setItemEdit] = useState({});

	const [openModal, setOpenModal] = useState({
		add    : false,
		delete : false,
		detail : false,
	});

	const handleModalOpen = (modal) => {
		openModal[modal] = true;
		setOpenModal({ ...openModal });
	};

	const handleModalClose = (modal) => {
		openModal[modal] = false;
		setOpenModal({ ...openModal });
	};

	useEffect(() => {
		handleReLoading();
	}, [filter]);

	const handleReLoading = () => {
		dispatch(saleCallSourceActions.fetchData({ ...filter }));
	};

	if (error) {
		notification.error({ message: 'Lỗi', description: error });
	}

	// Tạo nguồn mới
	const handleCreate = async (data) => {
		let [error, response] = await handleRequest(saleApi.callSourceAdd(data));
		let message = apiError('Tạo nguồn gọi điện thất bại', error, response);
		if (!message) {
			if (!response?.data?.id) {
				notification.error({ message: 'Thất bại', description: 'Chưa tạo được nguồn gọi điện' });
			} else {
				const skipped = response.skippedCount || 0;
				const added   = response.totalAdded   || response.data?.total || 0;
				if (skipped > 0) {
					notification.warning({
						message: 'Tạo nguồn thành công',
						description: `Đã thêm ${added} liên hệ. Bỏ qua ${skipped} số đã có lịch hẹn.`,
						duration: 6,
					});
				} else {
					notification.success({ message: 'Thành công', description: `Tạo nguồn thành công (${added} liên hệ)` });
				}
				dispatch(saleCallSourceActions.add(response.data));
				handleModalClose('add');
			}
		}
	};

	// Xóa nguồn
	const handleDelete = async () => {
		if (!itemEdit?.id) {
			notification.error({ message: 'Lỗi', description: 'Không có thông tin nguồn để xóa' });
			return;
		}
		let [error, response] = await handleRequest(saleApi.callSourceDelete(itemEdit.id));
		let message = apiError('Xóa nguồn gọi điện thất bại', error, response);
		if (!message) {
			notification.success({ message: 'Thành công', description: 'Xóa nguồn gọi điện thành công' });
			dispatch(saleCallSourceActions.delete(itemEdit.id));
			handleModalClose('delete');
		}
	};

	const handlePaginationChange = (page) => {
		dispatch(saleCallSourceActions.setFilter({ ...filter, page }));
	};

	return (
		<Fragment>
			<ActionBar title={'Nguồn gọi điện'}>
				<Button outline leftIcon={Icon.plusCircle} onClick={() => { setItemEdit({}); handleModalOpen('add'); }}>
					Thêm mới
				</Button>
				<Button outline onClick={handleReLoading}>{Icon.reload}</Button>
			</ActionBar>

			<div className="container">
				<div className="content">
					{loading && <Loading />}
					{items && (
						<SaleCallSourceTable
							items={items}
							pagination={pagination}
							onPaginationChange={handlePaginationChange}
							setItemEdit={setItemEdit}
							openModal={handleModalOpen}
						/>
					)}
				</div>

				{/* Modal thêm mới */}
				<Modal
					title="Thêm nguồn gọi điện"
					visible={openModal.add}
					onCancel={() => handleModalClose('add')}
					size={"xl"}
				>
					<SaleCallSourceUploadForm onHandleSubmit={handleCreate} />
				</Modal>

				{itemEdit?.id && (
					<Modal
						title={`${itemEdit?.name}`}
						visible={openModal.detail}
						onCancel={() => handleModalClose('detail')}
						size={"xl"}
					>
						<SaleCallSourceDetail item={itemEdit} />
					</Modal>
				)}

				{/* Modal xóa */}
				{itemEdit?.id && (
					<Modal
						title="Xóa nguồn gọi điện"
						visible={openModal.delete}
						onCancel={() => handleModalClose('delete')}
					>
						<p className="mt-2">
							Bạn muốn xóa bộ nguồn <b>{itemEdit?.name}</b>?
							<br />
							<span style={{ color: '#f5222d', fontSize: 13 }}>
								⚠️ Toàn bộ {itemEdit?.total} liên hệ trong bộ nguồn này cũng sẽ bị xóa.
							</span>
						</p>
						<div className="d-flex justify-content-end gap modal-bottom pd-2">
							<Button white leftIcon={Icon.close} onClick={() => handleModalClose('delete')}>Đóng</Button>
							<Button primary leftIcon={Icon.delete} onClick={handleDelete}>Xóa</Button>
						</div>
					</Modal>
				)}
			</div>
		</Fragment>
	);
}

export default SaleCallSource;

